import { DollarSign } from 'lucide-react';

import { CircleSkeleton, Skeleton } from '@/_components/progress';
import { SectionHeading } from '@/_containers';

export const HistoricalRevenueLoading = () => {
  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <SectionHeading text="Historical Revenue" icon={DollarSign} />
        <div className="flex items-center space-x-2">
          <Skeleton className="h-5 w-12 rounded-full" />
          <Skeleton className="h-4 w-32" />
        </div>
      </div>

      {/* Table skeleton */}
      <div className="mt-8">
        {/* Table headers */}
        <div className="border-muted/50 grid grid-cols-6 gap-8 border-b pb-3 dark:border-gray-400/10">
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
          <Skeleton className="mr-4 ml-auto h-4 w-16" />
        </div>

        {/* Table rows */}
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="border-muted/50 grid grid-cols-6 gap-8 border-b pt-2 pb-1 dark:border-gray-400/10">
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
            <CircleSkeleton className="mr-9 ml-auto h-6 w-6" />
          </div>
        ))}
      </div>
    </>
  );
};
